import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../../utils/api';
import tgApi from '../../utils/tgApi';

// 각 소스를 개별로 호출(allSettled)하여 일부 실패해도 나머지는 표시.
// 실패 목록(failed)·갱신시각(fetchedAt)을 함께 반환해 대시보드에서 신선도/에러를 노출한다.
const SOURCES = [
  ['dbRecordCount', () => api.get('/api/records/count')],
  ['tgMemberCount', () => tgApi.getMemberCount()],
  ['tgSendStats', () => tgApi.getSendStats()],
  ['tgHealth', () => tgApi.getHealth()],
  ['searchStats', () => api.get('/api/admin/search-logs-stats')],
  ['recentConsultations', () => tgApi.getRecentConsultations()],
  ['consultationStats', () => tgApi.getConsultationStats()],
  ['analytics', () => tgApi.getAnalyticsSummary(7)],
  ['autoReplyStats', () => tgApi.getAutoReplyStats()],
  ['autoReplies', () => tgApi.getAutoReplies({ limit: 6 })],
];

export const fetchDashboardData = createAsyncThunk(
  'dashboard/fetchData',
  async (_, { rejectWithValue }) => {
    try {
      const results = await Promise.allSettled(SOURCES.map(([, fn]) => fn()));
      const val = (i) => (results[i].status === 'fulfilled' ? results[i].value.data : null);
      // tgHealth 실패는 "오프라인"이라는 정상 상태이므로 실패 목록에서 제외
      const failed = SOURCES
        .map(([key], i) => ({ key, ok: results[i].status === 'fulfilled' }))
        .filter((s) => !s.ok && s.key !== 'tgHealth')
        .map((s) => s.key);

      return {
        dbRecordCount: val(0)?.count ?? null,
        tgMemberCount: val(1),
        tgSendStats: val(2),
        tgHealth: results[3].status === 'fulfilled' ? 'online' : 'offline',
        searchStats: val(4),
        recentConsultations: val(5) || [],
        consultationStats: val(6),
        analytics: val(7),
        autoReplyStats: val(8),
        autoReplies: val(9) || [],
        fetchedAt: Date.now(),
        failed,
      };
    } catch (err) {
      return rejectWithValue(err.message);
    }
  }
);

const dashboardSlice = createSlice({
  name: 'dashboard',
  initialState: {
    data: null,
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchDashboardData.pending, (state) => { state.loading = true; state.error = null; })
      .addCase(fetchDashboardData.fulfilled, (state, action) => { state.loading = false; state.data = action.payload; })
      .addCase(fetchDashboardData.rejected, (state, action) => { state.loading = false; state.error = action.payload; });
  },
});

export default dashboardSlice.reducer;
